import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e011bb6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container m-5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Поменять пароль")
const _hoisted_3 = {
  key: 0,
  class: "submit-btn d-flex",
  type: "submit"
}
const _hoisted_4 = {
  key: 1,
  class: "btn submit-btn",
  type: "submit",
  disabled: ""
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Загружается... ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Что-то пошло не так! Попробуйте обновить страницу и повторить")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_n_p = _resolveComponent("n-p")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.handleChangePassword,
      "validation-schema": _ctx.schema,
      onInvalidSubmit: _ctx.onInvalidSubmit,
      class: "shadow-lg",
      "data-test": "change-password-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_h1, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_TextInput, {
          value: _ctx.password,
          name: "password",
          type: _ctx.passwordFieldType,
          label: "Пароль",
          placeholder: "Новый пароль",
          "success-message": "Сложный и безопасный!"
        }, null, 8, ["value", "type"]),
        _createElementVNode("em", {
          class: _normalizeClass(["toggle-password fas", [_ctx.passwordFieldIcon]]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hidePassword = !_ctx.hidePassword))
        }, null, 2),
        _createVNode(_component_TextInput, {
          value: _ctx.confirmPassword,
          name: "confirmPassword",
          type: _ctx.passwordFieldType,
          label: "Подтвердите новый пароль",
          placeholder: "Введите пароль ещё раз",
          "success-message": "Запомните его!"
        }, null, 8, ["value", "type"]),
        _createElementVNode("em", {
          class: _normalizeClass(["toggle-password fas", [_ctx.passwordFieldIcon]]),
          "data-test": "toggle-password",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hidePassword = !_ctx.hidePassword))
        }, null, 2),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("button", _hoisted_3, "Подтвердить"))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("button", _hoisted_4, _hoisted_7))
          : _createCommentVNode("", true),
        _createVNode(_component_n_p, null, {
          default: _withCtx(() => [
            _createTextVNode("Обязательно активируйте новый пароль перейдя по ссылке в письме, которое мы вам пришлём на вашу почту " + _toDisplayString(_ctx.currentUser.email), 1)
          ]),
          _: 1
        }),
        (_ctx.isWrong)
          ? (_openBlock(), _createBlock(_component_n_p, {
              key: 2,
              class: "btn-danger"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
  ]))
}